import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './store';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        {/* <HashRouter>
            <App />
        </HashRouter> */}
        <BrowserRouter basename='/'>
            <App/>
        </BrowserRouter>
    </Provider>
);

serviceWorker.unregister();